/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_PriceInputs */

const et_plan_minimum_price = /** @type {(inputs: Plan_Minimum_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€349 / Kuus`)
};

const en_plan_minimum_price = /** @type {(inputs: Plan_Minimum_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€349 / Month`)
};

/**
* | output |
* | --- |
* | "€349 / Month" |
*
* @param {Plan_Minimum_PriceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_price = /** @type {((inputs?: Plan_Minimum_PriceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_PriceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_price(inputs)
	return en_plan_minimum_price(inputs)
});